import React, { Component, Suspense } from "react"
import Title from "containers/general/title"
import ReactTable from "react-table"
import moment from "moment"
import ReactSelect from "react-select"
import numeral from "numeral"
import settings from "settings"
import helpers from "helpers/helpers"
import currentUser from "helpers/currentUser"
import FullTable from "components/FullTable"
import cumulativeTraffic from "widgets/cumulativeWeeklyTraffic"
import lotTypes from "widgets/salesByLotTypePie"
import lotTypeBuilderStackedBar from "widgets/salesByLotTypeBar"
import getData from "helpers/asyncSubmitData"
import _ from "lodash"
import { toast } from "react-toastify"

let layout = "DefaultLayout"
let custom = _.get(settings, `weeklyRender`)
if (custom) layout = custom
const Layout = require(`../weeklyRender/${layout}`).default

class WeeklyRender extends Component {
	constructor(props) {
		super(props)
		let user = currentUser()
		let devVisisibility = _.get(settings, "weeklyDevUserVisibility")
		this.state = {
			columns: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Sale Type",
					accessor: "sale_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "sale_type"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Sale Date",
					accessor: "sale_date",
					filterMethod: (f, r) => helpers.tableText(f, r, "sale_date"),
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
				},
			],
			closingColumns: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Closing Date",
					accessor: "closing_date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				...(_.get(settings, `weekly.closingsDaysToClose`)
					? [
							{
								Header: "Days to Close",
								accessor: "days_to_close",
								filterMethod: (f, r) => helpers.tableText(f, r, "days_to_close"),
								Footer: (props) => helpers.tableAverages(props, "days_to_close", "0,0"),
							},
					  ]
					: []),
			],
			salesBreakoutTable: [
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				...(settings?.weekly?.salesBreakoutNeighborhoods
					? [
							{
								Header: "Neighborhood",
								accessor: "neighborhood",
								filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
							},
					  ]
					: []),
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Gross",
					accessor: "gross",
					filterMethod: (f, r) => helpers.tableText(f, r, "gross"),
					Footer: (props) => helpers.tableTotals(props, "gross", "0,0"),
				},
				{
					Header: "Cancels",
					accessor: "cancels",
					filterMethod: (f, r) => helpers.tableText(f, r, "cancels"),
					Footer: (props) => helpers.tableTotals(props, "cancels", "0,0"),
				},
				{
					Header: "Net",
					accessor: "net",
					filterMethod: (f, r) => helpers.tableText(f, r, "net"),
					Footer: (props) => helpers.tableTotals(props, "net", "0,0"),
				},
				{
					Header: "Closings",
					accessor: "closings",
					filterMethod: (f, r) => helpers.tableText(f, r, "closings"),
					Footer: (props) => helpers.tableTotals(props, "closings", "0,0"),
				},
				{
					Header: "Current Specs",
					accessor: "specs",
					filterMethod: (f, r) => helpers.tableText(f, r, "specs"),
					Footer: (props) => helpers.tableTotals(props, "specs", "0,0"),
				},
			],
			startColumns: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Start Date",
					accessor: "start_date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Sale Date",
					accessor: "sale_date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Square Feet",
					accessor: "sqft",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("0,0")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.tableText(f, r, "sqft"),
				},
			],
			cancelColumns: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "Address"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Cancel Date",
					accessor: "cancel_date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Reason",
					accessor: "reason",
					filterMethod: (f, r) => helpers.tableText(f, r, "reason"),
				},
			],
			specsColumns: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Under Construction Contract",
					accessor: "under_construction_contract",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.under_construction_contract
						})
						return numeral(total).format("0,0")
					},
				},
				{
					Header: "Under Construction No Contract",
					accessor: "under_construction_no_contract",
					filterMethod: (f, r) => helpers.tableText(f, r, "under_construction_no_contract"),
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.under_construction_no_contract
						})
						return numeral(total).format("0,0")
					},
				},
				{
					Header: "Move In Ready Specs",
					accessor: "move_in_ready_specs",
					filterMethod: (f, r) => helpers.tableText(f, r, "move_in_ready_specs"),
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.move_in_ready_specs
						})
						return numeral(total).format("0,0")
					},
				},
			],
			averageColumns: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Number of Sales",
					accessor: "number",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["number"]) {
								total += v["number"]
							}
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Average Sales Price",
					accessor: "average",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0")
						}
						return ""
					},
					Footer: (props) => {
						let number = 0
						let totalPrice = 0
						_.forEach(props.data, (v) => {
							number += v.number
							totalPrice += v._original.totalPrice
						})
						let total = totalPrice / number
						if (typeof total == "number") {
							return numeral(total).format("$0,0")
						}
						return total
					},
				},
			],
			user: currentUser(),
			emailPDF: false,
			emailAllPDFs: false,
		}
		let isDev = user?.group == 1 ? true : false
		let addonBuckets = ["columns", "closingColumns", "cancelColumns"]
		// Now add on the fields for sales/closings/cancels in the addonBuckets array.  This is so all developers can hide/show what they want to dev users.  Use the devOnly flag for public vs private.
		if (devVisisibility) {
			_.forEach(addonBuckets, (bucket) => {
				_.forEach(devVisisibility, (v) => {
					if (v.devOnly && !isDev) return
					if (v.type === "number") {
						this.state[bucket].push({
							Header: v.name,
							accessor: v.id,
							show: !isDev && v.devOnly ? false : true,
							filterMethod: (f, r) => helpers.tableText(f, r, v.id),
							Cell: (v) => {
								if (v.value) {
									return numeral(v.value).format("0,0")
								}
								return ""
							},
							Footer: (props) => helpers.tableTotals(props, v.id, "0,0"),
						})
					} else if (v.type === "date") {
						this.state[bucket].push({
							Header: v.name,
							accessor: v.id,
							show: !isDev && v.devOnly ? false : true,
							Cell: (v) => {
								if (v.value) {
									return moment.unix(v.value).format("MM/DD/YY")
								}
								return ""
							},
							filterMethod: (f, r) => helpers.dateFilter(f, r),
						})
					} else if (v.type == "dollar") {
						this.state[bucket].push({
							Header: v.name,
							accessor: v.id,
							show: !isDev && v.devOnly ? false : true,
							Cell: (v) => {
								if (v.value) {
									return numeral(v.value).format("$0,0")
								}
								return ""
							},
							filterMethod: (f, r) => helpers.tableText(f, r, v.id),
							Footer: (props) => helpers.tableTotals(props, v.id, "$0,0"),
						})
					} else if (v.type == "average") {
						this.state[bucket].push({
							Header: v.name,
							accessor: v.id,
							show: !isDev && v.devOnly ? false : true,
							Cell: (v) => {
								if (v.value) {
									return numeral(v.value).format("0,0")
								}
								return ""
							},
							filterMethod: (f, r) => helpers.tableText(f, r, v.id),
							Footer: (props) => helpers.tableAverages(props, v.id, "0,0.00"),
						})
					} else if (v.type === "text") {
						this.state[bucket].push({
							Header: v.name,
							accessor: v.id,
							show: !isDev && v.devOnly ? false : true,
							filterMethod: (f, r) => helpers.tableText(f, r, v.id),
						})
					}
				})
			})
		}
	}

	years = () => {
		let year = this.props.state.times.year
		let b = year - 15
		let ret = []
		while (b <= year) {
			ret.push({
				value: b,
				label: b,
			})
			b++
		}
		ret = _.reverse(ret)
		return ret
	}

	weeks = () => {
		let ret = []
		let i = 0
		while (i <= 53) {
			ret.push({
				value: i,
				label: i,
			})
			i++
		}

		return ret
	}

	internalTitle = () => {
		let title =
			settings.weekly && settings.weekly.summary
				? `${this.props.state.name} Sales Report`
				: `${this.props.state.name} Weekly Report`
		return (
			<>
				<Title title={title} showDate={false} cutPadding={true} />
				<div className="twoCol">
					<p className="content weekly__date">
						Week {this.props.state.selectedWeek} | {this.props.state.startDayName || "Monday"}{" "}
						{moment.unix(this.props.state.startWeek).format("MMMM D") + " "}-{" "}
						{this.props.state.endDayName || "Sunday"}{" "}
						{moment.unix(this.props.state.endWeek).format("MMMM D")}
					</p>
					<div className="weekly__yearsSelects">
						<div className="weekly__optionBox">
							<p>Report:</p>
							<ReactSelect
								name={`active`}
								className="reactSelect"
								options={[
									...(settings.weekly && settings.weekly.summary
										? [{ value: "summary", label: "Summary" }]
										: []),
									{ value: "week", label: "Week" },
									{ value: "ytd", label: "Year To Date" },
									{ value: "life", label: "Life of Project" },
								]}
								value={this.props.state.options.active}
								onChange={(v) => this.props.changeReportType(v)}
								onBlur={() => {}}
							/>
						</div>
						<div className="weekly__optionBox">
							<p>Year:</p>
							<ReactSelect
								name={`years`}
								className="reactSelect"
								options={this.years()}
								value={this.props.state.options.year}
								onChange={(v) => this.props.changeReport(v, "year")}
								onBlur={() => {}}
							/>
						</div>
						<div className="weekly__optionBox">
							<p>Week:</p>
							<ReactSelect
								name={`week`}
								className="reactSelect"
								options={this.weeks()}
								value={this.props.state.options.week}
								onChange={(v) => this.props.changeReport(v, "week")}
								onBlur={() => {}}
							/>
						</div>
					</div>
				</div>
			</>
		)
	}

	islandTitle = () => {
		return (
			<>
				<Title title={this.props.title.title} showDate={false} cutPadding={true} />
				<p className="content weekly__date pb-2">{this.props.title.date}</p>
			</>
		)
	}

	render() {
		if (settings.weekly && settings.weekly.summary && this.props.state.active == "summary") {
			//! Weekly Summary View 
			return (
				<div className="body__stage" id="stage">
					<div className="imageGroup">
						{this.props.type == "island" ? this.islandTitle() : this.internalTitle()}
						{this.props.state.weekly_message && (
							<div className="weeklyMessage content">
								<h4 className="font-bold py-4">Current Weekly Message</h4>
								<div dangerouslySetInnerHTML={{ __html: this.props.state.weekly_message }}></div>
							</div>
						)}
						{settings?.enabled?.weeklyPDFButtonSend &&
						this?.props?.type === "internal" &&
						this.state?.user?.group === 1 ? (
							<div className="flex justify-end">
								<a
									className="btn text-xs my-2"
									onClick={async () => {
										if (this.state.emailPDF === false) {
											this.setState({ emailPDF: true })
										} else if (this.state.emailPDF === true) {
											// fire off event to server to build the PDF and email
											toast.warn("Building PDF, please wait..")
											this.props.props.loadingStatus(true)
											let resp = await getData("mainIngest", {
												action: "emailWeeklyPDF",
												report: settings.enabled?.weeklyPDFButtonSend,
												property: this.props.state.property.id,
												week: this.props.state.selectedWeek,
												year: this.props.state.selectedYear,
											})
											if (resp.status === 200) {
												toast.success("Weekly PDF Sent")
											}
											this.setState({ emailPDF: false })
											this.props.props.loadingStatus(false)
										}
									}}>
									{this.state.emailPDF === false ? "Email Single PDF" : "Confirm?"}
								</a>
								<a
									className="btn text-xs my-2 ml-2"
									onClick={async () => {
										if (this.state.emailAllPDFs === false) {
											this.setState({ emailAllPDFs: true })
										} else if (this.state.emailAllPDFs === true) {
											// fire off event to server to build the PDF and email
											toast.warn("Building PDF, please wait..")
											this.props.props.loadingStatus(true)
											let resp = await getData("mainIngest", {
												action: "emailWeeklyPDF",
												report: settings.enabled?.weeklyPDFButtonSend,
												allProperties: true,
											})
											if (resp.status === 200) {
												toast.success("Weekly PDF Sent")
											}
											this.setState({ emailAllPDFs: false })
											this.props.props.loadingStatus(false)
										}
									}}>
									{this.state.emailAllPDFs === false ? "Email All PDFs" : "Confirm?"}
								</a>
							</div>
						) : (
							""
						)}
						<div className="quickStats">
							<ul className="quickStats__list">
								<li className="quickStats__item quickStats__item--dual">
									<div className="quickStats__dualBox">
										<div>
											<div className="quickStats__stat">
												{this.props.state.weeklyTotals.gross.toLocaleString()}
											</div>
											<div className="quickStats__type">Gross Sales</div>
										</div>
										<div className="quickStats__subType">
											YTD: {this.props.state.summary.ytd.weeklyTotals.gross.toLocaleString()}
										</div>
									</div>
								</li>
								<li className="quickStats__item quickStats__item--dual">
									<div className="quickStats__dualBox">
										<div>
											<div className="quickStats__stat">
												{this.props.state.weeklyTotals.net.toLocaleString()}
											</div>
											<div className="quickStats__type">Net Sales</div>
										</div>
										<div className="quickStats__subType">
											YTD: {this.props.state.summary.ytd.weeklyTotals.net.toLocaleString()}
										</div>
									</div>
								</li>
								<li className="quickStats__item quickStats__item--dual">
									<div className="quickStats__dualBox">
										<div>
											<div className="quickStats__stat">
												{this.props.state.weeklyTotals.busts.toLocaleString()}
											</div>
											<div className="quickStats__type">Cancellations</div>
										</div>
										<div className="quickStats__subType">
											YTD: {this.props.state.summary.ytd.weeklyTotals.busts.toLocaleString()}
										</div>
									</div>
								</li>
								<li className="quickStats__item quickStats__item--dual">
									<div className="quickStats__dualBox">
										<div>
											<div className="quickStats__stat">
												{this.props.state.weeklyTotals.closings.toLocaleString()}
											</div>
											<div className="quickStats__type">Closings</div>
										</div>
										<div className="quickStats__subType">
											YTD: {this.props.state.summary.ytd.weeklyTotals.closings.toLocaleString()}
										</div>
									</div>
								</li>
								<li className="quickStats__item quickStats__item--dual">
									<div className="quickStats__dualBox">
										<div>
											<div className="quickStats__stat">
												{this.props.state.weeklyTotals.starts.toLocaleString()}
											</div>
											<div className="quickStats__type">Starts</div>
										</div>
										<div className="quickStats__subType">
											YTD: {this.props.state.summary.ytd.weeklyTotals.starts.toLocaleString()}
										</div>
									</div>
								</li>
								{/* <li className="quickStats__item quickStats__item--dual">
									<div className="quickStats__dualBox">
										<div>
											<div className="quickStats__stat">
												{this.props.state.weeklyTotals?.copilot.toLocaleString()}
											</div>
											<div className="quickStats__type">CoPilot Traffic</div>
										</div>
										<div className="quickStats__subType">
											YTD: {this.props.state.summary.ytd.weeklyTotals?.copilot.toLocaleString()}
										</div>
									</div>
								</li> */}
								{_.get(settings, "weekly.splitTraffic") ? (
									<>
										<li className="quickStats__item quickStats__item--dual">
											<div className="quickStats__dualBox">
												<div>
													<div className="quickStats__stat">
														{this.props.state.weeklyTotals.builderTraffic.toLocaleString()}
													</div>
													<div className="quickStats__type">Builder Traffic</div>
												</div>
												<div className="quickStats__subType">
													YTD:{" "}
													{this.props.state.summary.ytd.weeklyTotals.builderTraffic.toLocaleString()}
												</div>
											</div>
										</li>
										<li className="quickStats__item quickStats__item--dual">
											<div className="quickStats__dualBox">
												<div>
													<div className="quickStats__stat">
														{this.props.state.weeklyTotals.welcomeTraffic.toLocaleString()}
													</div>
													<div className="quickStats__type">Welcome Traffic</div>
												</div>
												<div className="quickStats__subType">
													YTD:{" "}
													{this.props.state.summary.ytd.weeklyTotals.welcomeTraffic.toLocaleString()}
												</div>
											</div>
										</li>
									</>
								) : (
									<>
										<li className="quickStats__item quickStats__item--dual">
											<div className="quickStats__dualBox">
												<div>
													<div className="quickStats__stat">
														{this.props.state.weeklyTotals.traffic.toLocaleString()}
													</div>
													<div className="quickStats__type">Traffic</div>
												</div>
												<div className="quickStats__subType">
													YTD:{" "}
													{this.props.state.summary.ytd.weeklyTotals.traffic.toLocaleString()}
												</div>
											</div>
										</li>
									</>
								)}
							</ul>
						</div>
						<div className="content">
							{this.props.methods.summaryCustomModules(this.props.state, this.props.props)}
						</div>
						<div className="content">
							<h2 style={{ marginBottom: 20 }}>Sales</h2>
							<FullTable
								data={this.props.methods.buildSalesTable(this.props.state, this.props.props)}
								columns={this.state.columns}
								pageSize={5}
								name="weekly__sales"
								title="Weekly Sales"
							/>
							<h2>Closings</h2>
							<p className="mid">Detailed information is available in the Closings module.</p>
							<FullTable
								data={this.props.methods.buildClosingsTable(this.props.state, this.props.props)}
								columns={this.state.closingColumns}
								pageSize={5}
								name="weekly__closings"
								title="Weekly Closings"
							/>
							<h2>Cancels</h2>
							<p className="mid">Detailed information is available in the Cancels module.</p>
							<FullTable
								data={this.props.methods.buildCancelsTable(this.props.state, this.props.props)}
								columns={this.state.cancelColumns}
								name="weekly__cancels"
								title="Weekly Cancels"
								pageSize={5}
							/>
							{/* <h2 style={{ marginBottom: 20 }}>Starts</h2>
							<FullTable
								data={this.props.methods.buildStartsTable(this.props.state, this.props.props)}
								columns={this.state.startColumns}
								name="weekly__starts"
								title="Weekly Starts"
							/> */}
							{!settings.disabled.weeklySpecs && (
								<>
									<h2 style={{ marginBottom: 20 }}>Current Specs</h2>
									<FullTable
										data={this.props.state.specs}
										columns={this.state.specsColumns}
										pageSize={5}
										name="weekly__specs"
										title="Weekly Specs"
									/>
								</>
							)}
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">{cumulativeTraffic(this.props.props, this.props.state)}</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							{_.get(settings, `enabled.weeklyAnalytics`) &&
								_.get(this.props.state, `webAnalytics`) &&
								this.props.state.active == "summary" && (
									<>
										<h2>Web Analytics</h2>
										<div className="quickStats quickStats--light">
											<ul className="quickStats__list">
												<li className="quickStats__item">
													<div>
														<div className="quickStats__stat">
															{numeral(
																_.get(this.props.state, `webAnalytics[0].users`)
															).format("0,0")}
														</div>
														<div className="quickStats__type">Users</div>
													</div>
												</li>
												<li className="quickStats__item">
													<div>
														<div className="quickStats__stat">
															{numeral(
																_.get(
																	this.props.state,
																	`webAnalytics[0].percentNewUsers`
																)
															).format("0,0")}
															%
														</div>
														<div className="quickStats__type">Percent New Users</div>
													</div>
												</li>
												<li className="quickStats__item">
													<div>
														<div className="quickStats__stat">
															{numeral(
																_.get(this.props.state, `webAnalytics[0].sessions`)
															).format("0,0")}
														</div>
														<div className="quickStats__type">Sessions</div>
													</div>
												</li>
												<li className="quickStats__item">
													<div>
														<div className="quickStats__stat">
															{numeral(
																_.get(this.props.state, `webAnalytics[0].pageviews`)
															).format("0,0")}
														</div>
														<div className="quickStats__type">Pageviews</div>
													</div>
												</li>
												<li className="quickStats__item">
													<div>
														<div className="quickStats__stat">
															{numeral(
																_.get(this.props.state, `webAnalytics[0].bounceRate`)
															).format("0,0")}
															%
														</div>
														<div className="quickStats__type">Bounce Rate</div>
													</div>
												</li>
												<li className="quickStats__item">
													<div>
														<div className="quickStats__stat">
															{numeral(
																_.get(
																	this.props.state,
																	`webAnalytics[0].pagesPerSession`
																)
															).format("0,00.00")}
														</div>
														<div className="quickStats__type">Pages Per Session</div>
													</div>
												</li>
												<li className="quickStats__item">
													<div>
														<div className="quickStats__stat">
															{numeral(
																_.get(
																	this.props.state,
																	`webAnalytics[0].avgSessionDuration`
																)
															).format("0,00.00")}
														</div>
														<div className="quickStats__type">Average Session Duration</div>
													</div>
												</li>
												<li className="quickStats__item">
													<div>
														<div className="quickStats__stat">
															{numeral(
																_.get(
																	this.props.state,
																	`webAnalytics[0].sessionsPerUser`
																)
															).format("0,00.00")}
														</div>
														<div className="quickStats__type">Sessions Per User</div>
													</div>
												</li>
											</ul>
										</div>
									</>
								)}
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<div className="statBox__row statBox__row--double">
								<div className="statBox__box">
									{lotTypes(this.props.props, this.props.state.summary.ytd)}
								</div>
								<div className="statBox__box">
									<h3 className="statBox__title">
										<span className="bug">YTD</span>Builder Sales
									</h3>
									{this.props.methods.builderSales(this.props.state.summary.ytd, this.props.props)}
								</div>
							</div>
							<div className="statBox__row statBox__row--double">
								<div className="statBox__box">
									<h3 className="statBox__title">
										<span className="bug">YTD</span>Sales By Builder
									</h3>
									{this.props.methods.builderSalesAndLotType(
										this.props.state.summary.ytd,
										this.props.props
									)}
								</div>
								<div className="statBox">
									{_.get(this.state, `user.group`) == 1 &&
									_.get(settings, `enabled.weekly.lotTypeBuilderStackedBar`) ? (
										<div className="statBox__row hideMobile">
											<div className="statBox__box">
												{lotTypeBuilderStackedBar(
													this.props.props,
													this.props.state.summary.ytd
												)}
											</div>
										</div>
									) : (
										""
									)}
								</div>
							</div>
							<div className="statBox__row statBox__row">
								<div className="statBox__box">
									<h3 className="statBox__title">
										<span className="bug">YTD</span>Sales by Salespeople
									</h3>
									{this.props.methods.salesBySalespeople(
										this.props.state.summary.ytd,
										this.props.props
									)}
								</div>
							</div>
							<div className="statBox__row statBox__row--triple">
								<div className="statBox__box">
									<h3 className="statBox__title" style={{ marginBottom: 3 }}>
										<span className="bug">YTD</span>Realtor Sales
									</h3>
									{this.props.methods.realtorPercent(this.props.state.summary.ytd, this.props.props)}
								</div>
								<div className="statBox__box">
									<h3 className="statBox__title">
										<span className="bug">YTD</span>Cancellation Rate
									</h3>
									{this.props.methods.bustRate(this.props.state.summary.ytd, this.props.props)}
								</div>
								<div className="statBox__box">
									<h3 className="statBox__title">
										<span className="bug">YTD</span>Sales Dirt vs Spec
									</h3>
									{this.props.methods.dirtVsSpec(this.props.state.summary.ytd, this.props.props)}
									<p className="small">
										Spec vs Dirt Sale Summary evaluates the gross sales for the week, only taking
										into account cancellations if the contract was both written and canceled in the
										reporting week
									</p>
								</div>
							</div>
							{_.get(this.state, `user.group`) == 1 || !_.get(settings, `weekly.restrictSalesMeter`) ? (
								<>
									{this.props.methods.salesMeter(this.props.state, this.props.props, this.props.type)}
								</>
							) : (
								""
							)}
						</div>
					</div>
					<div className="imageGroup">
						<div className="statBox hidden lg:block">
							{_.get(this.state, `user.group`) == 1 &&
							_.get(settings, `enabled.weekly.varianceByLotType`) ? (
								<div className="statBox__row hideMobile">
									<div className="statBox__box">
										<h3 className="statBox__title">Sales Variance by Lot Type</h3>
										{this.props.methods.salesVariance(
											this.props.state,
											this.props.props,
											this.props.type
										)}
									</div>
								</div>
							) : (
								""
							)}
						</div>
						<div className="content">
							{_.get(this.state, `user.group`) == 1 &&
							_.get(settings, `enabled.weekly.lotTypeBuilderBar`) ? (
								<div className="statBox__row hideMobile">
									<div className="statBox__box">
										<h3 className="statBox__title">Home Sales - Lot Type &amp; Builder - Net</h3>
										{this.props.methods.lotTypeBuilderBar(
											this.props.state,
											this.props.props,
											this.props.type
										)}
									</div>
								</div>
							) : (
								""
							)}
							{_.get(settings, `enabled.weeklyAverages`) && (
								<>
									<h2>Average Prices</h2>
									<p className="mid">Based on gross sales.</p>
									<FullTable
										data={this.props.state.averages}
										columns={this.state.averageColumns}
										name="weekly__averagePrices"
										title="Weekly Average Prices"
									/>
								</>
							)}
						</div>
					</div>
				</div>
			)
		} else {
			return <Layout {...this} />
		}
	}
}

export default WeeklyRender
